// extracted by mini-css-extract-plugin
module.exports = {"ProgressText":"ProgressBar_ProgressText__2Dm_m","ProgressBar":"ProgressBar_ProgressBar__3SRig","inner":"ProgressBar_inner__ob3s6","progress":"ProgressBar_progress__20v60"};